const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = function isPrivatePath(path) {
	const privateRoute = generalSettings.data.siteMetaData.privateRoute || "";
	if (privateRoute === "" || !path) return false;
	return privateRoute === "/" || path === privateRoute || path.includes(privateRoute);
};
